import { BsError } from './bs-error';

export class ApiErrorLog {
  constructor(service, method: string, error: BsError) {
    this.service = service;
    this.method = method;
    this.errorCode = error.code;
    this.errorMessage = error.message;
  }

  public service: string;
  public method: string;
  public errorCode: number;
  public errorMessage: string;

  public logParams(): { [key: string]: any } {
    const params = new Map<string, any>();
    params.set('service', this.service);
    params.set('method', this.method);
    params.set('errorCode', this.errorCode);
    params.set('errorMessage', this.errorMessage);
    return params;
  }
}
